import { Page } from '../types/Page'

export const changePage = (view: Page | undefined) => {
  return {
    type: 'CHANGE_PAGE',
    payload: view,
  }
}
